import React from "react";

// Import image
import aiChatSupport from "../../assets/img/Ai-Chat-support.webp";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { Link } from "react-router-dom";

const ECommerceAIPage = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            E-Commerce Web Design & Development with AI-Powered Solutions
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4 col-lg-4">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={aiChatSupport}
                    className="img-fluid rounded w-45"
                    alt="AI & Cutting-Edge Technology"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-8 col-lg-8">
              <h1>
                Revolutionizing Online Stores with AI & Cutting-Edge Technology
              </h1>
              <p className="font-size-p">
                At Epic-x, we specialize in AI-powered eCommerce website design
                and development, ensuring high-performance, scalable, and
                conversion-driven online stores. Our solutions integrate the
                latest AI automation, UX/UI design, mobile optimization, and SEO
                strategies to maximize your digital success.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Why Choose Us Section */}
      <header className="sub-heading-section">
        <h1>Why Choose Our AI-Driven E-Commerce Development?</h1>
      </header>
      <div className="container mt-5">
        <div className="row">
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ AI-Powered Personalization</h5>
            <p className="font-size-p">
              Deliver real-time personalized shopping experiences with AI-driven
              product recommendations and dynamic pricing.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Mobile-First & Responsive Design</h5>
            <p className="font-size-p">
              Optimized for seamless performance across all devices, enhancing
              user engagement and conversions.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Lightning-Fast Load Speeds</h5>
            <p className="font-size-p">
              Improve rankings and user retention with ultra-fast website
              performance and AI-based caching techniques.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Voice Search & Smart SEO</h5>
            <p className="font-size-p">
              Implement AI-enhanced voice search optimization and schema markup
              to boost search engine visibility.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ Automated Chatbots & Virtual Assistants</h5>
            <p className="font-size-p">
              Enhance customer support with AI-powered chatbots for instant
              query resolution.
            </p>
          </div>
          <div
            className="col-md-6 col-lg-4 mb-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h5>✅ AI-Driven Content & Image Optimization</h5>
            <p className="font-size-p">
              Generate SEO-friendly content and optimize images using AI to
              enhance page rankings.
            </p>
          </div>

          {/* Call to Action Section */}
          <section className="cta-section">
            <h2>Supercharge Your E-Commerce Business with AI!</h2>
            <p className="font-size-p">
              Get a future-ready eCommerce store powered by AI, SEO, and
              cutting-edge web technologies.
            </p>
            <a href="#" className="btn-epix-x btn-primary btn-lg">
              🚀 Get a Free Consultation Today!
            </a>
          </section>

          {/* Contact Information Section */}
          <div className="row g-4 mb-5">
            <div
              className="col-md-6 col-lg-3 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="contact-add-item">
                <div className="contact-icon text-primary mb-4">
                  <i className="fas fa-map-marker-alt fa-2x"></i>
                </div>
                <div>
                  <h4>Website</h4>
                  <p className="mb-0">
                    <a href="https://epic-x.io/">epic-x.io</a>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3 wow fadeInUp"
              data-wow-delay="0.4s"
            >
              <div className="contact-add-item">
                <div className="contact-icon text-primary mb-4">
                  <i className="fas fa-envelope fa-2x"></i>
                </div>
                <div>
                  <h4>Mail Us</h4>
                  <p className="mb-0">techsupport@epic-x.io</p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3 wow fadeInUp"
              data-wow-delay="0.6s"
            >
              <div className="contact-add-item">
                <div className="contact-icon text-primary mb-4">
                  <i className="fa fa-phone-alt fa-2x"></i>
                </div>
                <div>
                  <h4>Call Us</h4>
                  <p className="mb-0">+91-8925696660</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ECommerceAIPage;
